module.exports = __webpack_public_path__ + "static/media/kaduha_mugano_mushubi_road4.a0f224f3.jpg";